import { fileTypeConfigs, fileTypes } from "../consts";

const defaultFileType = fileTypeConfigs[fileTypes.image].extensions[0];

const transformFileSize = (fileSize) => {
  if (fileSize < 1000) {
    return `${fileSize}B`;
  }

  if (fileSize < 1000 * 1000) {
    return `${Math.round(fileSize / 1000)}KB`;
  } else {
    return `${parseFloat((fileSize / 1000 / 1000).toFixed(2))}MB`;
  }
};

const readFile = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result));
    reader.readAsArrayBuffer(file);
  });
};

const getFileBlob = (blob, type) => {
  const fileBlob = new Blob([blob], { type: type ?? defaultFileType });

  return fileBlob;
};

const downloadFile = (file, filename, extention) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.download = `${filename}.${extention}`;
  link.href = url;
  link.click();
};

const getFileExtention = (file) => {
  const extension = file?.type?.split("/")[1] ?? null;

  return extension;
};

const fileUtils = {
  transformFileSize,
  readFile,
  getFileBlob,
  downloadFile,
  getFileExtention
};

export default fileUtils;
